import { OctButtonComponent } from "@components/oct-button/oct-button.component";
import { OctSvgComponent } from "@components/oct-svg/oct-svg.component";

import { NgTemplateOutlet } from "@angular/common";
import { Component, input, output, type TemplateRef } from "@angular/core";

@Component({
  selector: "oct-toast",
  styleUrls: ["./oct-toast.component.scss"],
  imports: [OctButtonComponent, OctSvgComponent, NgTemplateOutlet],
  template: `
    @if (shown()) {
      @if (!compact() && askConfirmation()) {
        <div
          class="toast-overlay"
          role="presentation"
          (click)="triggerEvent(false)"></div>
      }
      <div
        class="toast"
        [class]="type()"
        [attr.compact]="compact() ? 'true' : null"
        animate.enter="toast-enter"
        animate.leave="toast-leave"
        [style.top]="top()"
        [style.width]="width()">
        <section class="toast__info">
          <oct-svg
            class="icon"
            [path]="'svgs/' + type() + '.svg'"
            aria-hidden="true" />
          <p class="toast-message">
            <span class="toast-message__header">{{ header() }}</span>
            @if (!compact()) {
              @if (personalizedContent() && templateRef()) {
                <ng-container
                  [ngTemplateOutlet]="templateRef()!"
                  [ngTemplateOutletContext]="templateContext() || {}" />
              } @else {
                <span class="toast-message__content">{{ content() }}</span>
              }
            }
          </p>
          @if (compact()) {
            <button
              class="close"
              type="button"
              aria-label="Cerrar alerta"
              (click)="triggerEvent(true)">
              <oct-svg path="svgs/close.svg" />
            </button>
          }
        </section>
        @if (!compact()) {
          <section class="toast__buttons">
            @if (askConfirmation()) {
              <oct-button
                size="sm"
                [text]="cancelText()"
                type="secondary"
                (click)="triggerEvent(false)" />
            }
            <oct-button
              size="sm"
              [text]="confirmText()"
              (click)="triggerEvent(true)" />
          </section>
        }
      </div>
    }
  `,
})
export class OctToastComponent {
  type = input<"info" | "warning" | "error" | "success">("info");
  compact = input(true);
  header = input.required<string>();
  content = input.required<string>();
  askConfirmation = input(false);
  shown = input(true);
  confirmText = input("Entendido");
  cancelText = input("Cancelar");
  top = input("16px");
  width = input("440px");
  personalizedContent = input(false);
  templateRef = input<TemplateRef<unknown> | null>(null);
  templateContext = input<unknown | null>(null);

  acceptEvent = output();
  cancelEvent = output();

  triggerEvent(event: boolean) {
    if (event) this.acceptEvent.emit();
    else this.cancelEvent.emit();
  }
}

export interface IOctToastComponent {
  type: "info" | "warning" | "error" | "success";
  compact: boolean;
  header: string;
  content: string;
  askConfirmation: boolean;
  shown: boolean;
  confirmText: string;
  cancelText: string;
  top: string;
  width: string;
  personalizedContent: boolean;
}
